import React from "react";
import { cn } from "../../../../utils/cn"

const NoData = ({ className, content, color = "#9D9D9D" }) => {
  return (
    <div className={cn("flex flex-col items-center justify-center h-full", className)}>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 24 24"
        className="w-24 h-24"
        style={{ fill: color, stroke: color }}
        xmlns="http://www.w3.org/2000/svg">
        <path d="M4.02381 3.78307C4.12549 3.32553 4.5313 3 5 3H19C19.4687 3 19.8745 3.32553 19.9762 3.78307L21.9762 12.7831C21.992 12.8543 22 12.927 22 13V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V13C2 12.927 2.00799 12.8543 2.02381 12.7831L4.02381 3.78307ZM5.80217 5L4.24662 12H9C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12H19.7534L18.1978 5H5.80217ZM16.584 14C15.8124 15.7659 14.0503 17 12 17C9.94968 17 8.1876 15.7659 7.41604 14H4V19H20V14H16.584Z">
        </path>
      </svg>
      <h1 className="mt-4 font-semibold text-[28px] text-[#4D4D4D]">{content}</h1>
    </div>
  );
};

export default NoData;
